import { useMemo, useState } from 'react';
import { useScreenClass } from 'react-grid-system';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';
import theme from '../styles/theme';
import Button from './Button';
import FlexBox, { FlexGrow } from './FlexBox';
import { ClickableIcon } from './Icon';
import Input, { InputTextArea } from './Input';
import MinimalSelect from './MinimalSelect';
import Modal from './Modal';
import { Icon as Muicon } from '@mui/material';
import { IconsMaterial } from '../hooks/materialicons';
import Status from '../types/enum/Status';
import { SaveButton } from './PillarOverviewModify';

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid rgb(219, 219, 219);
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 20px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const Label = styled.h5`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
type IconPickerModalProps = {
  isOpen?: boolean;
  data: { icon: string };
  onSubmit: (icon: string) => void;
  setOpen: (x: boolean) => void;
};
interface SkillwInputs {
  title: string;
  assessment_description: string;
  complexity_level: string;
}
const IconPickerModal = ({
  isOpen,
  setOpen, onSubmit, data }: IconPickerModalProps): JSX.Element => {
  const [selectedIcon, setSelectedIcon] = useState<string>(data.icon);
  const onSubmitOverview = (icon: string) => {
    onSubmit(icon);
  }

  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: {
            zIndex: '999958',
          },
          content: {
            maxWidth: '500px',
            padding: '0 24px',
            color: 'black',
            background: '#FFFFFF',
            border: '1px solid #E7EBEE',
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.07)',
            borderRadius: '8px',
          },
        }}>
        <CustomFlex>
          <FlexGrow>
            <Header>Select Icon</Header>
          </FlexGrow>
          <ClickableIcon
            size={3.125}
            fixedWidth={false}
            color="black"
            name="close"
            onClick={() => setOpen(false)}
          />
        </CustomFlex>
        <CustomFlex
          style={{
            borderBottom: 'none',
            alignItems: 'flex-start',
            overflowY: 'scroll',
          }}>
          <FlexGrow>
            <CustomFlexPlain className='visible-scrollbar' style={{ maxHeight: '350px', overflowY: 'scroll', padding: 0 }}>
              <FlexGrow>
                {IconsMaterial.map((icon: string) => (
                  <>
                    {selectedIcon && selectedIcon !== '' ? (
                      <>
                        {selectedIcon === icon ? (
                          <Button onClick={() => setSelectedIcon('')} style={{
                            marginRight: '4px', marginBottom: '4px', color: 'white',
                            backgroundColor: 'black'
                          }} type='button'>
                            <Muicon>{icon}</Muicon>
                          </Button>
                        ) : (
                          <Button onClick={() => setSelectedIcon(icon)} style={{ marginRight: '4px', marginBottom: '4px' }} type='button'>
                            <Muicon>{icon}</Muicon>
                          </Button>
                        )}
                      </>
                    ) : (
                      <Button onClick={() => setSelectedIcon(icon)} style={{ marginRight: '4px', marginBottom: '4px' }} type='button'>
                        <Muicon>{icon}</Muicon>
                      </Button>
                    )}
                  </>
                ))}
              </FlexGrow>
            </CustomFlexPlain>
            <FlexBox style={{ paddingTop: '8px' }}>
              <FlexGrow>
              </FlexGrow>
              <Button
                onClick={() => setOpen(false)}
                className="reduce_opct_onhover"
                style={{
                  border: "2px solid #64748B",
                  padding: "8px 40px",
                  fontSize: "14px",
                }}>
                Cancel
              </Button>
              <SaveButton
                type='submit'
                disabled={selectedIcon === ''}
                className="reduce_opct_onhover"
                onClick={() => onSubmitOverview(selectedIcon)}
                style={{
                  // border: "2px solid #64748B",
                  padding: "8px 40px",
                  color: "white",
                }}>
                Save
              </SaveButton>
            </FlexBox>
          </FlexGrow>
        </CustomFlex>
      </Modal>
    </>
  );
};

export default IconPickerModal;
